// src/components/StyledTable.tsx
import styled from 'styled-components';
import { Paper, Table, TableHead, TableRow, TableCell, TableBody, Card, CardContent } from '@material-ui/core';

export const StyledPaper = styled(Paper)`
	background-color: #424242 !important;
	color: white;
`;

export const StyledTable = styled(Table)`
  	min-width: 650px;

	.MuiTableCell-stickyHeader {
		background-color: #424242 !important;
		font-weight: bold !important;
	}
`;

export const StyledTableCell = styled(TableCell) <{ warning?: boolean }>`
  	color: ${p => p.warning ? 'yellow' : 'white'} !important;
  	border-bottom: 1px solid rgba(255, 255, 255, 0.12) !important;
	font-weight: ${p => p.warning ? 'bold' : 'normal'} !important;
`;

export const StyledTableRow = styled(TableRow)`
	&:nth-of-type(odd) {
		background-color: rgba(255, 255, 255, 0.1);
	}
`;

export const StyledCard = styled(Card)`
	background-color: #616161 !important;
	color: white !important;
`;

export const StyledCardContent = styled(CardContent)`
  	padding: 8px !important;
`;
